import React from "react";
import { ArrowRight, Stethoscope, Microscope, HeartPulse, Brain, Activity, Bone } from "lucide-react";

const COURSES = [
  { icon: HeartPulse, title: "Internal Medicine", chips: ["Cardiology", "Endocrine", "GIT"], questions: "2,400+ MCQs" },
  { icon: Microscope, title: "Pathology", chips: ["General", "Systemic", "Hematology"], questions: "1,600+ MCQs" },
  { icon: Brain, title: "Psychiatry & Neuro", chips: ["DSM-V", "Pharmaco", "Imaging"], questions: "900+ MCQs" },
  { icon: Bone, title: "Orthopaedics", chips: ["Fractures", "Joints", "Spine"], questions: "1,100+ MCQs" },
  { icon: Activity, title: "Anaesthesia", chips: ["Drugs", "Airway", "Monitoring"], questions: "700+ MCQs" },
  { icon: Stethoscope, title: "Community Medicine", chips: ["Biostats", "Epidemiology", "Programs"], questions: "1,200+ MCQs" },
];

export default function Courses() {
  return (
    <section id="courses" className="py-20 md:py-28 bg-slate-50/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-700 bg-blue-50 px-3 py-1.5 rounded-full">
              <span className="h-1.5 w-1.5 rounded-full bg-blue-600" /> Courses
            </div>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 mt-4">
              Subject-wise courses for every NEET PG topic
            </h2>
          </div>
          <p className="text-slate-600 max-w-md">
            Master all 19 subjects with structured chapters, high-yield notes and AI-powered MCQs.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {COURSES.map((c, i) => {
            const I = c.icon;
            return (
              <div
                key={c.title}
                data-testid={`course-card-${i}`}
                className="bg-white border border-slate-200 rounded-2xl p-6 lift group"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-11 w-11 rounded-xl bg-blue-50 ring-1 ring-blue-600/10 flex items-center justify-center">
                    <I className="h-5 w-5 text-blue-700" />
                  </div>
                  <h3 className="font-heading text-lg font-bold text-slate-900">{c.title}</h3>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {c.chips.map((chip) => (
                    <span key={chip} className="text-[11px] font-medium px-2.5 py-1 rounded-full bg-slate-100 text-slate-700">{chip}</span>
                  ))}
                </div>
                <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-between">
                  <span className="text-sm font-semibold text-blue-700">{c.questions}</span>
                  <span className="text-slate-400 group-hover:text-blue-700 transition-colors inline-flex items-center text-sm font-medium">
                    Explore <ArrowRight className="h-4 w-4 ml-1" />
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
